import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { saveSession } from "../api";

const styles = {
  page: { display: "flex", minHeight: "100vh", alignItems: "center", justifyContent: "center" },
  card: { background: "#fff", padding: 32, borderRadius: 12, width: 360, boxShadow: "0 2px 12px rgba(0,0,0,0.08)" },
  tabs: { display: "flex", marginBottom: 20, borderRadius: 8, overflow: "hidden", border: "1px solid #ddd" },
  tab: (active) => ({
    flex: 1, padding: "10px 0", textAlign: "center", cursor: "pointer",
    background: active ? "#2563eb" : "#f0f0f0", color: active ? "#fff" : "#333", fontWeight: 600,
  }),
  input: { width: "100%", padding: 10, marginBottom: 12, border: "1px solid #ccc", borderRadius: 6 },
  button: { width: "100%", padding: 11, background: "#2563eb", color: "#fff", border: "none", borderRadius: 6, fontWeight: 600, cursor: "pointer" },
  error: { color: "#dc2626", marginBottom: 12, fontSize: 14 },
  link: { textAlign: "center", marginTop: 14, fontSize: 14, color: "#2563eb", cursor: "pointer" },
};

export default function Login() {
  const [role, setRole] = useState("admin");
  const [mode, setMode] = useState("login"); // login | register (admin only)
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const navigate = useNavigate();

  const update = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      if (role === "admin" && mode === "register") {
        const res = await api.post("/api/auth/admin/register", form);
        saveSession(res.data.token, "admin", res.data.admin);
        navigate("/admin");
      } else if (role === "admin") {
        const res = await api.post("/api/auth/admin/login", { email: form.email, password: form.password });
        saveSession(res.data.token, "admin", res.data.admin);
        navigate("/admin");
      } else {
        const res = await api.post("/api/auth/labour/login", { email: form.email, password: form.password });
        saveSession(res.data.token, "labour", res.data.labour);
        navigate("/labour");
      }
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={{ marginTop: 0, textAlign: "center" }}>Attendance System</h2>

        <div style={styles.tabs}>
          <div style={styles.tab(role === "admin")} onClick={() => { setRole("admin"); setError(""); }}>Admin</div>
          <div style={styles.tab(role === "labour")} onClick={() => { setRole("labour"); setMode("login"); setError(""); }}>Labour</div>
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={submit}>
          {role === "admin" && mode === "register" && (
            <input style={styles.input} placeholder="Full name" value={form.name} onChange={update("name")} required />
          )}
          <input style={styles.input} type="email" placeholder="Email" value={form.email} onChange={update("email")} required />
          <input style={styles.input} type="password" placeholder="Password" value={form.password} onChange={update("password")} required />
          <button style={styles.button} type="submit">
            {role === "admin" && mode === "register" ? "Create admin account" : "Log in"}
          </button>
        </form>

        {role === "admin" && (
          <div style={styles.link} onClick={() => setMode(mode === "login" ? "register" : "login")}>
            {mode === "login" ? "New admin? Start your subscription" : "Already have an account? Log in"}
          </div>
        )}

        <div style={{ ...styles.link, fontSize: 13, color: "#666" }} onClick={() => setShowForgotPassword(true)}>
          Forgot password?
        </div>
      </div>

      {showForgotPassword && <ForgotPasswordModal onClose={() => setShowForgotPassword(false)} />}
    </div>
  );
}

function ForgotPasswordModal({ onClose }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post("/api/auth/forgot-password", { email });
      setMessage(res.data.message);
    } catch (err) {
      setMessage("Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 50 }}>
      <div style={{ background: "#fff", padding: 28, borderRadius: 12, width: 340 }}>
        <h3 style={{ marginTop: 0 }}>Reset your password</h3>
        {message ? (
          <>
            <p style={{ fontSize: 14 }}>{message}</p>
            <button style={styles.button} onClick={onClose}>Close</button>
          </>
        ) : (
          <form onSubmit={submit}>
            <p style={{ fontSize: 13, color: "#666" }}>Enter your email and we'll send you a reset link.</p>
            <input style={styles.input} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <button style={styles.button} type="submit" disabled={busy}>{busy ? "Sending..." : "Send reset link"}</button>
            <div style={{ textAlign: "center", marginTop: 10, fontSize: 13, color: "#666", cursor: "pointer" }} onClick={onClose}>Cancel</div>
          </form>
        )}
      </div>
    </div>
  );
}